import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Flickity from 'flickity';

export default el => {
    const dom = $(el);
    let flkty = null;

    const update = () => {
        if (Viewport.width < 750) {
            const innerHeight = window.innerHeight - 117;
            dom.css({
                height: innerHeight
            });
        } else {
            dom.css('height', null);
        }
    };

    const init = () => {
        Viewport.on('resize', update);
        update();

        flkty = new Flickity(el, {
            wrapAround: true,
            dragThreshold: 10,
            prevNextButtons: false,
            pageDots: true,
            setGallerySize: false,
            resize: true,
            cellSelector: '[data-item]'
        });
        flkty.resize();

        flkty.on('dragStart', () => {
            document.ontouchmove = e => e.preventDefault();
        });
        flkty.on('dragEnd', () => {
            document.ontouchmove = () => true;
        });
    };

    const destroy = () => {
        flkty.destroy();
        Viewport.off('resize');
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/FrontpageHero.js